// src/til/query-hooks/transformers.ts
var transformPost = (data) => {
  const { brief, id, slug, markdownContent, readTimeInMinutes, title } = data;
  return {
    id,
    title,
    slug,
    brief,
    mContent: markdownContent,
    readTimeInMinutes
  };
};

export { transformPost };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-4DVXBYWE.mjs.map